import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from '@gray/domain/http/jwt.service';

@Injectable({providedIn: 'root'})
export class CoachNoAuthGuard {
  constructor(
    private router: Router,
    private jwtService: JwtService,
  ) {
  }

  canActivate() {
    const token = this.jwtService.getToken();
    if (token && (token.length > 3)) {
      this.router.navigateByUrl('/dashboard');
      return false;
    }

    return true;
  }
}
